import type CreativeSDK from '@cesdk/cesdk-js';

export async function getSceneString(editor: CreativeSDK): Promise<string> {
	return editor.engine.scene.saveToString(['data', 'buffer', 'http', 'https', 'bundle', 'blob']);
}

export async function getSceneArchive(editor: CreativeSDK): Promise<Blob> {
	return editor.engine.scene.saveToArchive();
}
